import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import OrganizerDashboard from "./pages/OrganizerDashboard";
import BidderDashboard from "./pages/BidderDashboard";
import Header from "./components/Header";
import { AuctionProvider } from "./context/AuctionContext";
import { ThemeProvider } from "./context/ThemeContext";
import "./App.css";
import OrganizerHome from "./pages/OrganizerHome";
import LandingPage from "./pages/LandingPage";
import Profile from "./pages/Profile";
import PlayerReg from "./pages/PlayerReg";
import GuestDashboard from "./pages/GuestDashboard";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { analytics, logEvent } from "./firebase";
import { Auth } from "./pages/auth";

// Component to track page views
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (analytics) {
      // Get page name from pathname
      const pageName = location.pathname === "/" 
        ? "Home" 
        : location.pathname
            .split("/")
            .filter(Boolean)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

      logEvent(analytics, "page_view", {
        page_title: pageName,
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <ThemeProvider>
      <AuctionProvider>
        <Router>
          <PageViewTracker />
          <Header />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/sign-in" element={<Auth page="login" />} />
            <Route path="/sign-up" element={<Auth page="register" />} />
            <Route path="/guest/:gameId" element={<GuestDashboard />} />
            <Route path="/organizer/dashboard/:gameId" element={<OrganizerDashboard />} />
            <Route path="/organizer" element={<OrganizerHome />} />
            <Route path="/bidder" element={<BidderDashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path = "player-reg/:gameId" element={<PlayerReg />} />
            <Route path = "*" element= {<Navigate to ="/" />} />
          </Routes>
        </Router>
      </AuctionProvider>
    </ThemeProvider>
  );
}

export default App;